exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2w55fXrzyP6nmQSo1Fa0SB{cursor:pointer}._2w55fXrzyP6nmQSo1Fa0SB .caret{visibility:hidden}._2w55fXrzyP6nmQSo1Fa0SB:hover .caret{visibility:visible}", ""]);

// exports
exports.locals = {
	"dropdowntoggle": "_2w55fXrzyP6nmQSo1Fa0SB"
};